/**
 * Browser-side Better Auth client for apps/web.
 *
 *   import { authClient } from '@/auth/client';
 *   authClient.signIn.email({ email, password });
 *   const { data: session } = authClient.useSession();
 *   authClient.signOut();
 */
import { createAuthClient, adminClient } from '@bookaburra/auth/client';

// Better Auth requires an absolute URL — paths fail validation with
// "Invalid base URL". apps/web is a TanStack Router SPA so module
// evaluation only runs in the browser, making `window` always
// available here. The handler is mounted at /api/auth in
// apps/web/src/worker.ts on the same origin.
//
// The adminClient plugin adds `authClient.admin.impersonateUser` /
// `.stopImpersonating` — used by the /sudo super-admin surface.
export const authClient = createAuthClient({
  baseURL: `${window.location.origin}/api/auth`,
  plugins: [adminClient()],
});
